import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { EventsService } from "src/app/services/event/event.service";


  /**
   * The Directive calculates the height of the first small/med container, assigns the height to all small/med containers to avoid gaps in the grid, especially in IE.
   * Also, it calculates the height of a Large container based on small/med containers' height and padding (5px), and assigns the height to all Large containers found
   */
  @Directive({
    selector: '[setEqualHeight]'
  })
  export class EqualHeightDirective {
  
    categorySelectionMade:boolean = false;
    public windowWidth:number;
    // class name that matches height
    @Input()
    setEqualHeight: any;
  
    constructor(private el: ElementRef, public events:EventsService) {
        
        setTimeout((() => {
            this.windowWidth = window.innerWidth;
            this.equalHeight(this.el.nativeElement, this.setEqualHeight, this.windowWidth);
        }).bind(this), 500);

        this.events.subscribe("event:keywordaction",
            () => {
                this.categorySelectionMade = true;
                this.windowWidth = window.innerWidth;
                if(this.categorySelectionMade) {
                    setTimeout((() => {
                        this.equalHeight(this.el.nativeElement, this.setEqualHeight, this.windowWidth);
                    }).bind(this), 500);
                    this.equalHeight(this.el.nativeElement, this.setEqualHeight, this.windowWidth);
                }
            }
        );

    }
  
    ngOnInit() {
        
    }

    ionViewDidEnter(){
            setTimeout((() => {
                this.windowWidth = window.innerWidth;
                this.equalHeight(this.el.nativeElement, this.setEqualHeight, this.windowWidth);
            }).bind(this), 500);
    }
    ngOnDestroy() {
        this.events.unsubscribe("event:keywordaction");
    }
    resizeTimeout = null;
    @HostListener('window:resize') 
    onWindowResize() {
      //debounce resize, avoid multiple resize events
      if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout((() => {
          this.windowWidth = window.innerWidth;
          this.equalHeight(this.el.nativeElement, this.setEqualHeight, this.windowWidth);
      }).bind(this), 500);
    }
  
    equalHeight(parentElem: HTMLElement, className: string, windowWidth:number) {
        //match height logic here
        if (!parentElem) return;
        
        const childElems = parentElem.getElementsByClassName(className);
        if (!childElems) return;
  
        const childElemsLarge = parentElem.getElementsByClassName('large-modified-height');
        if (!childElemsLarge) return;

        let windowWidthDefined:number = windowWidth;
        if(!childElemsLarge) return;

        const largeTileBreakpoint:number = 992;
  
        // reset all (except large) child container heights
        Array.from(childElems).forEach((x: HTMLElement) => {
            x.style.height = 'auto';
            x.style.width = 'auto';
        })
        // reset large child container heights
        Array.from(childElemsLarge).forEach((x: HTMLElement) => {
          x.style.height = 'auto';
          x.style.width = 'auto';
        })
        
        // get height from a small/med container
        if(childElems[0]){
            const getRegTileHeight = childElems[0].clientHeight;
            const getRegTileWidth = getRegTileHeight;
            if(getRegTileHeight && getRegTileWidth) {
                //set height for Large container, consider padding and IE padding rendering
                const setLargeTileHeight = (getRegTileHeight * 2) + 17.9;
    
                // apply max height to all small and medium containers to fix IE issues
                Array.from(childElems)
                    .forEach((x: HTMLElement) => {
                        x.style.height = `${getRegTileHeight}px`;
                        x.style.width = `${getRegTileHeight}px`;
                    });
        
                //apply height to large tile containers only if under 768 (or set breakpoint) - else apply reg tile height
                if(windowWidthDefined >= largeTileBreakpoint) {
                    Array.from(childElemsLarge)
                    .forEach((x: HTMLElement) => {
                        x.style.height = `${setLargeTileHeight}px`;
                        x.style.width = `${setLargeTileHeight}px`;
                        }
                    );
                } else {
                    Array.from(childElemsLarge)
                    .forEach((x: HTMLElement) => {
                            x.style.height = `${getRegTileHeight}px`;
                            x.style.width = `${getRegTileHeight}px`;
                        }
                    );
                }
            }
            
        }
    }
  }